import React from "react";
import MyRoutineWorkspace from "../components/my-routine/MyRoutineWorkspace";
import "../components/my-routine/MyRoutineView.css";

export { default as MyRoutineWorkspace } from "../components/my-routine/MyRoutineWorkspace";

export default function MyPrepPage({ Experience } = {}) {
  return <section className="MyRoutineStandalone">
    <header><span>Personal workspace</span><h1>My Routine</h1><p>Build private routines, import your Drills &amp; Exercises, and prepare at your own pace.</p></header>
    <MyRoutineWorkspace Experience={Experience} />
  </section>;
}
